/* ==========================================================================
   RadioButtonRxjs > Client
   ========================================================================== */

/* Import modules */
const { elementExist } = require('@bluekiri/alexandria/helpers/domHelpers');
const { randomId } = require('@bluekiri/alexandria/helpers/dataHelpers');

const prototype = require('./prototype');
const config = require('./config');

/**
 * RadioButtonRxjs component
 * @param {selector} String selector for the component in the client side.
 */
module.exports = function RadioButtonRxjs(selector = '[data-component=RadioButtonRxjs]', configuration = {}) {
    if (elementExist(selector)) {
        /* Instance */
        const instance = Object.create(prototype);

        /* Element */
        instance.element = document.querySelector(selector);

        /* Hooks */
        instance.hooks = {
            input: instance.element.querySelector('input'),
            label: instance.element.querySelector('label')
        };

        /* ID for pairing */
        instance.id = randomId(randomId('radio-button'));

        /* Config */
        instance.config = {
            ...config(),
            ...configuration,
            ...(function getConfig() {
                if (!instance.element.dataset.config) return '';

                const result = JSON.parse(instance.element.dataset.config);
                instance.element.dataset.config = '';
                return result;
            })()
        };

        /* Init */
        instance.init();

        /* Return */
        return instance;
    }
};
